import postal from 'postal';

export default function (title) {
  var channel = postal.channel('viewTitle');
  channel.publish('viewtitle.change', {
    viewTitle: title
  });
}



// WEBPACK FOOTER //
// ./src/helpers/setViewTitle.js